export const assetsData = [
  {
    id: 'AST-001',
    name: 'Conveyor Belt A1',
    type: 'Conveyor System',
    location: 'Production Line A',
    status: 'operational',
    condition: 'good',
    manufacturer: 'Siemens',
    model: 'CB-2500X',
    serialNumber: 'SN-CB-001-2023',
    installDate: '2023-03-15',
    lastMaintenance: '2024-01-05',
    nextMaintenance: '2024-02-05',
    criticality: 'high',
    operatingHours: 8760,
    efficiency: 95,
    downtime: 12,
    workOrders: 3,
    specifications: {
      power: '15 kW',
      speed: '2.5 m/s',
      capacity: '500 kg/m'
    }
  },
  {
    id: 'AST-002',
    name: 'Hydraulic Press HP-300',
    type: 'Hydraulic Equipment',
    location: 'Workshop B',
    status: 'operational',
    condition: 'excellent',
    manufacturer: 'Bosch Rexroth',
    model: 'HP-300-PRO',
    serialNumber: 'SN-HP-002-2022',
    installDate: '2022-08-20',
    lastMaintenance: '2024-01-08',
    nextMaintenance: '2024-02-08',
    criticality: 'medium',
    operatingHours: 6240,
    efficiency: 98,
    downtime: 8,
    workOrders: 2,
    specifications: {
      pressure: '300 bar',
      force: '3000 kN',
      strokeLength: '500 mm'
    }
  },
  {
    id: 'AST-003',
    name: 'Cooling Tower CT-01',
    type: 'HVAC System',
    location: 'Roof Level',
    status: 'maintenance',
    condition: 'fair',
    manufacturer: 'BAC',
    model: 'VXT-1500',
    serialNumber: 'SN-CT-003-2021',
    installDate: '2021-05-10',
    lastMaintenance: '2023-12-20',
    nextMaintenance: '2024-01-20',
    criticality: 'critical',
    operatingHours: 12480,
    efficiency: 85,
    downtime: 24,
    workOrders: 5,
    specifications: {
      capacity: '1500 kW',
      flowRate: '2500 m³/h',
      fanPower: '45 kW'
    }
  },
  {
    id: 'AST-004',
    name: 'Overhead Crane OC-15',
    type: 'Lifting Equipment',
    location: 'Assembly Hall',
    status: 'operational',
    condition: 'good',
    manufacturer: 'Konecranes',
    model: 'CXT-15000',
    serialNumber: 'SN-OC-004-2020',
    installDate: '2020-11-30',
    lastMaintenance: '2024-01-05',
    nextMaintenance: '2024-04-05',
    criticality: 'high',
    operatingHours: 15600,
    efficiency: 92,
    downtime: 16,
    workOrders: 4,
    specifications: {
      capacity: '15 tons',
      span: '25 m',
      liftHeight: '12 m'
    }
  },
  {
    id: 'AST-005',
    name: 'Gearbox GB-250',
    type: 'Power Transmission',
    location: 'Drive System',
    status: 'operational',
    condition: 'good',
    manufacturer: 'SEW-Eurodrive',
    model: 'K97-DRN250',
    serialNumber: 'SN-GB-005-2023',
    installDate: '2023-01-12',
    lastMaintenance: '2024-01-12',
    nextMaintenance: '2024-04-12',
    criticality: 'medium',
    operatingHours: 7800,
    efficiency: 96,
    downtime: 6,
    workOrders: 1,
    specifications: {
      ratio: '1:50',
      torque: '2500 Nm',
      inputSpeed: '1450 rpm'
    }
  },
  {
    id: 'AST-006',
    name: 'Electrical Panel EP-Main',
    type: 'Electrical System',
    location: 'Main Distribution',
    status: 'operational',
    condition: 'excellent',
    manufacturer: 'Schneider Electric',
    model: 'Prisma Plus P',
    serialNumber: 'SN-EP-006-2022',
    installDate: '2022-06-15',
    lastMaintenance: '2023-12-15',
    nextMaintenance: '2024-06-15',
    criticality: 'critical',
    operatingHours: 8760,
    efficiency: 99,
    downtime: 2,
    workOrders: 1,
    specifications: {
      voltage: '400V',
      current: '630A',
      frequency: '50Hz'
    }
  },
  {
    id: 'AST-007',
    name: 'Air Compressor AC-500',
    type: 'Pneumatic System',
    location: 'Utility Room',
    status: 'operational',
    condition: 'good',
    manufacturer: 'Atlas Copco',
    model: 'GA500VSD+',
    serialNumber: 'SN-AC-007-2021',
    installDate: '2021-09-08',
    lastMaintenance: '2024-01-11',
    nextMaintenance: '2024-02-11',
    criticality: 'high',
    operatingHours: 10920,
    efficiency: 94,
    downtime: 18,
    workOrders: 3,
    specifications: {
      pressure: '8 bar',
      capacity: '500 l/s',
      power: '315 kW'
    }
  },
  {
    id: 'AST-008',
    name: 'Steam Boiler SB-01',
    type: 'Boiler System',
    location: 'Boiler Room',
    status: 'operational',
    condition: 'excellent',
    manufacturer: 'Viessmann',
    model: 'Vitoplex 300',
    serialNumber: 'SN-SB-008-2019',
    installDate: '2019-04-22',
    lastMaintenance: '2024-01-02',
    nextMaintenance: '2025-01-02',
    criticality: 'critical',
    operatingHours: 18240,
    efficiency: 97,
    downtime: 8,
    workOrders: 2,
    specifications: {
      capacity: '5000 kg/h',
      pressure: '16 bar',
      efficiency: '97%'
    }
  },
  {
    id: 'AST-009',
    name: 'Centrifugal Pump CP-120',
    type: 'Pump System',
    location: 'Pump Station',
    status: 'maintenance',
    condition: 'fair',
    manufacturer: 'Grundfos',
    model: 'NK 150-315',
    serialNumber: 'SN-CP-009-2022',
    installDate: '2022-02-28',
    lastMaintenance: '2024-01-09',
    nextMaintenance: '2024-03-09',
    criticality: 'medium',
    operatingHours: 9360,
    efficiency: 88,
    downtime: 32,
    workOrders: 4,
    specifications: {
      flowRate: '120 m³/h',
      head: '85 m',
      power: '45 kW'
    }
  },
  {
    id: 'AST-010',
    name: 'Ventilation System VS-North',
    type: 'HVAC System',
    location: 'North Wing',
    status: 'operational',
    condition: 'good',
    manufacturer: 'Systemair',
    model: 'AHU-5000',
    serialNumber: 'SN-VS-010-2020',
    installDate: '2020-07-14',
    lastMaintenance: '2023-11-14',
    nextMaintenance: '2024-02-14',
    criticality: 'medium',
    operatingHours: 14600,
    efficiency: 91,
    downtime: 14,
    workOrders: 2,
    specifications: {
      airFlow: '5000 m³/h',
      pressure: '800 Pa',
      power: '22 kW'
    }
  },
  {
    id: 'AST-011',
    name: 'Industrial Furnace IF-02',
    type: 'Heat Treatment',
    location: 'Heat Treatment Area',
    status: 'operational',
    condition: 'good',
    manufacturer: 'Nabertherm',
    model: 'N 500/85 HA',
    serialNumber: 'SN-IF-011-2021',
    installDate: '2021-12-03',
    lastMaintenance: '2024-01-15',
    nextMaintenance: '2024-04-15',
    criticality: 'high',
    operatingHours: 6240,
    efficiency: 93,
    downtime: 20,
    workOrders: 3,
    specifications: {
      temperature: '1200°C',
      volume: '500 L',
      power: '85 kW'
    }
  },
  {
    id: 'AST-012',
    name: 'Packaging Line PL-03',
    type: 'Packaging Equipment',
    location: 'Packaging Area',
    status: 'operational',
    condition: 'excellent',
    manufacturer: 'Bosch Packaging',
    model: 'SVE 2520 D',
    serialNumber: 'SN-PL-012-2023',
    installDate: '2023-07-18',
    lastMaintenance: '2024-01-06',
    nextMaintenance: '2024-02-06',
    criticality: 'medium',
    operatingHours: 4680,
    efficiency: 99,
    downtime: 4,
    workOrders: 1,
    specifications: {
      speed: '120 ppm',
      bagSize: '50-500g',
      power: '12 kW'
    }
  }
];